import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const useFilterParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onFilterChange = useCallback(
    (filters) => {
      const params = new URLSearchParams(searchParams);

      // Update or remove each filter parameter
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          params.set(key, value);
        } else {
          params.delete(key);
        }
      });

      // Update the URL search params
      setSearchParams(params);
    },
    [searchParams, setSearchParams]
  );

  // Initialize filters from URL on component mount
  const getInitialFilters = useCallback(() => {
    const initialFilters = {
      patientName: searchParams.get("patientName") || "",
      startDate: searchParams.get("startDate") || "",
      endDate: searchParams.get("endDate") || "",
      entryType: searchParams.get("entryType") || "",
      page: searchParams.get("page") || "",
    };

    return initialFilters;
  }, [searchParams]);

  return { onFilterChange, getInitialFilters };
};

export default useFilterParams;
